import React from 'react';
import { TeamSelector } from '../TeamSelector';
import { SeasonSelector } from '../season-selector/SeasonSelector';

interface TeamDetailsHeaderProps {
  teamName: string;
  availableSeasonsWithLeagues: Array<{
    season: string;
    league: string;
    country: string;
  }>;
  selectedSeasons: string[];
  onSeasonToggle: (season: string) => void;
  onClearSelection: () => void;
}

export const TeamDetailsHeader: React.FC<TeamDetailsHeaderProps> = ({
  teamName,
  availableSeasonsWithLeagues,
  selectedSeasons,
  onSeasonToggle,
  onClearSelection
}) => {
  return (
    <div className="mb-8">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-3xl font-bold">{teamName} Statistics</h1>
        <TeamSelector currentTeam={teamName} />
      </div>
      
      <SeasonSelector
        availableSeasons={availableSeasonsWithLeagues}
        selectedSeasons={selectedSeasons}
        onSeasonToggle={onSeasonToggle}
        onClearSelection={onClearSelection}
      />
    </div>
  );
};